import { generateActions } from "../utils";

export const GET_LANDING_DATA = generateActions("GET_LANDING_DATA");
export const COMPANY_FORM_SUBMISSION = generateActions("COMPANY_FORM_SUBMISSION");
